/* eslint-disable max-len */

// Validation regex
export const STRING_VALIDATION_REGEX = /^[a-zA-Z ]+$/;
export const NUMBER_VALIDATION_REGEX = /^\d+$/;
export const EMAIL_VALIDATION_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

// US_ZIP_REGEX - Regex for US zip codes
export const US_ZIP_REGEX = /^\d{5}([ -]\d{4})?$/;

// Canada_ZIP_REGEX - Regex for Canadian zip codes
export const CANADA_ZIP_REGEX = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/;

// ZIP CODE Validation REGEX
export const ZIP_REGEX = { US: US_ZIP_REGEX, CA: CANADA_ZIP_REGEX };

export const COUNTRY_LIST = [
  { countryId: 229, name: 'United States', abbreviation: 'US' },
  { countryId: 39, name: 'Canada', abbreviation: 'CA' },
];

export const GET_STATES_LIST_API = `${process.env.REACT_APP_ACCOUNT_ONBOARDING_API}/v1/countries/$countryId$/states`;
export const GET_INDUSTRY_LIST_API = `${process.env.REACT_APP_ACCOUNT_ONBOARDING_API}/v1/industries`;
export const GET_BUSINESS_LIST_API = `${process.env.REACT_APP_ACCOUNT_ONBOARDING_API}/v1/industries/$industryId$/business-segments`;
export const GET_CUSTOMER_REFERRALS_API = `${process.env.REACT_APP_ACCOUNT_ONBOARDING_API}/v1/customer-referrals`;
export const CREATE_ORG_V2_API = `${process.env.REACT_APP_ACCOUNT_ONBOARDING_API}/v2/organizations`;
export const LAUNCH_DARKLY_CLIENT_ID = `${process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID}`;
export const FORGOT_PWD_LINK = `${process.env.REACT_APP_FORGOT_PASSWORD_LINK}`;
export const LOGIN_URL = `${process.env.REACT_APP_LOGIN_URL}`;

export const EAGLEVIEW_DOT_COM_URL = 'https://www.eagleview.com';
export const TERMS_OF_USE_URL = `${EAGLEVIEW_DOT_COM_URL}/terms`;
export const PRIVACY_POLICY_URL = `${EAGLEVIEW_DOT_COM_URL}/privacy-statement`;

export const RegistrationFieldNames = {
  email: 'Email',
  firstName: 'First name',
  lastName: 'Last name',
  company: 'Company',
  industry: 'Industry',
  businessSegment: 'Business segment',
  country: 'Country',
  contactPhone: 'Phone',
  contactCity: 'City',
  contactState: 'State',
  contactAddress1: 'Address 1',
  contactZipCode: 'Zip code',
  shippingEmail: 'Shipping email',
  billingEmail: 'Billing email',
  billingFirstName: 'Billing first name',
  billingLastName: 'Billing last name',
  billingCompany: 'Billing company',
  billingPhone: 'Billing Phone',
  billingCity: 'Billing City',
  billingState: 'Billing State',
  billingAddress1: 'Billing Address 1',
  billingZipCode: 'Billing Zip code',
  refer: 'Referral Id',
};

export const RegistrationFieldErrorStates = {
  MISSING: 'MISSING',
  VALID: 'VALID',
  INVALID: 'INVALID',
  DUPLICATE: 'DUPLICATE',
};
